export default "data:image/webp;base64,UklGRkAAAABXRUJQVlA4TDQAAAAvJ4AGADAMQA1AcQTbN6x5HcEeBNk28zeZyGTu8BAEkAZDSGGCh7r/ExDOZ+7gTjes+g8A"